import {Card as C} from './Card';
import {Header} from './Header';
import {Content} from './Content';
import {HeaderTabs} from './HeaderTabs';
import {useCloseCard} from  './useCloseCard';

export const Card = Object.assign(C, {Header, HeaderTabs, Content, useCloseCard})
